<template>
    <main id="content" class="layout-content">
        <div class="container">
            <router-link to="/" class="back-link font-bold font-bai">
                {{ $t("app.Home") }}
            </router-link>
            <div class="font-bai" v-if="page.id">
                <h1
                    class="text-center font-balo font-bold"
                    v-html="page.title.rendered"
                ></h1>
                <div class="layout-container">
                    <p v-html="page.content.rendered"></p>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { get, filter, find } from "lodash";
import { setDescriptionPage } from "@/helper/helper";
export default {
    name: "LayoutPage",
    mounted() {
        let { path } = this.$route;
        const pageMenus = filter(this.menus, item => item.object === "page");
        const pageObject = find(
            pageMenus,
            item => `/page${item.path}` === path
        );
        if (pageObject) {
            this.getPage(pageObject.object_id).then(() => {
                setDescriptionPage(get(this.page, "acf.meta_description", ""));
            });
        } else {
            this.$router.push("/");
        }
    },
    computed: {
        ...mapState({
            page: state => get(state, "app.page", {}),
            menus: state => get(state, "app.menu.menus", [])
        })
    },
    methods: {
        ...mapActions("app", ["getPage"])
    },
    watch: {
        $route(to) {
            let { path } = to;

            const pageMenus = filter(
                this.menus,
                item => item.object === "page"
            );
            const pageObject = find(
                pageMenus,
                item => `/page${item.path}` === path
            );
            if (pageObject) {
                this.getPage(pageObject.object_id);
            } else {
                this.$router.push("/");
            }
        }
    }
};
</script>
